import { secondsToFormattedLabel } from '../../utils/date';

export default class TrimRecordingsController {
  constructor($state, $scope, Broadcast, Recording, $q, $timeout, $uibModal) {
    'ngInject';
    this.$state = $state;
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.$uibModal = $uibModal;

    this.broadcast = Broadcast.get({ id: $state.params.id });
    this.recording = Recording.get({ id: $state.params.recording });

    this.segmentRange = [0, 0];
    this.startSeconds = 0;
    this.stopSeconds = 0;
    this.onChangeBounds = (startSeconds, stopSeconds, startSegment, stopSegment) => {
      this.startSeconds = startSeconds;
      this.stopSeconds = stopSeconds;
      this.segmentRange = [startSegment, stopSegment];
    };

    this.loadingPromises = [this.broadcast.$promise, this.recording.$promise];
  }

  showPreviewModal() {
    const { $uibModal, $timeout } = this;

    $uibModal.open({
      template: require('./modal-trim-preview.html'),
      controller: ($scope, $uibModalInstance) => {
        'ngInject';
        $scope.cancel = () => $uibModalInstance.dismiss('cancel');
        $scope.title = 'Preview Trimmed Recording';
        $scope.broadcast = this.broadcast;
        $scope.options = {
          autostart: true,
          // TODO: ticketId = admin_token?
          //ticketId: BROADCAST_TICKET,
          trimSeconds: {
            // Support for v3 player
            start: this.startSeconds,
            stop: this.stopSeconds,
          },
          onLoadBroadcast: (b) => {
            // Support for v2 player
            b.start_segment = this.segmentRange[0];
            b.stop_segment = this.segmentRange[1];
          },
        };
      },
    });
  }

  saveChanges() {
    this.isSaving = true;
    this.recording.start_segment = '';
    this.recording.stop_segment = '';
    this.recording.start_seconds = this.startSeconds;
    this.recording.stop_seconds = this.stopSeconds;
    this.recording.$update(
      () => {
        window.location.replace(`${window.VUE_DASHBOARD_ROOT}/broadcasts/${this.$state.params.id}`);
      },
      () => {
        this.isSaving = false;
        alert('Unable to save trimmed recording. Please try again.');
      }
    );
  }
}



// WEBPACK FOOTER //
// ./app/pages/events/trim-recordings.js